<input type="number" (focusin)="onFocusIn($event)" (focusout)="onFocusOut($event)" [formControl]="numberForm" matInput [placeholder]="placeholder" />
